import GdDlysjgClientParamDetailModal from './gd-dlysjg-client-param-detail-modal.vue'
export default GdDlysjgClientParamDetailModal
